import { AUTO_LOGIN_ACTION, AUTO_LOGOUT_ACTION, LOGIN_ACTION, LOGOUT_ACTION, SET_AUTO_LOGOUT_MUTATION, SET_USER_DETAILS, SET_USER_TOKEN } from "@/store/storeconstants";
import axios from 'axios'
import config from "../../../config";
let timer = '';
export default{
    
   async [LOGIN_ACTION](context,payload){
    context.dispatch(LOGOUT_ACTION);
   await axios.get(config.api_url+'User/Authenticate',{
    params: {
      Username: payload.Email,
      Password: payload.Password
    }
   }).then(function (response) {
    if(response.status==200)
    {
      if(response.data.success)
      {
        let expiryTime= +response.data.data.expiryTime;
        timer = setTimeout(()=>{
         context.dispatch(AUTO_LOGOUT_ACTION);
        },expiryTime*1000);

        localStorage.setItem('token',JSON.stringify(response.data.data.token));
        context.commit(SET_USER_TOKEN,{
              token:response.data.data.token,
        })
      }
      localStorage.setItem('userDetails',JSON.stringify(response.data));
      context.commit(SET_USER_DETAILS,{
        userDetails:response.data,
      })
    }
  })
  .catch(function (error) {
    console.log('login api error',error);
    throw error;
  });
  },

  [AUTO_LOGIN_ACTION](context)
  {
    let token=localStorage.getItem('token')
    let userDetailsString=localStorage.getItem('userDetails')
    if(userDetailsString)
    {
      let userDetails = JSON.parse(userDetailsString);
      let expirationTime = userDetails.data.expiryTime; //- new Date().getTime();

    //   if (expirationTime < 10000) {
    //     context.dispatch(AUTO_LOGOUT_ACTION);
    // } else {
        timer = setTimeout(() => {
            context.dispatch(AUTO_LOGOUT_ACTION);
        }, expirationTime*1000);
   // }

      context.commit(SET_USER_DETAILS,{
        userDetails:userDetails,
      })
    }
    if(token)
    {
      context.commit(SET_USER_TOKEN,{
        token:JSON.parse(token),
      })
    }
  },

  [LOGOUT_ACTION](context){
    context.commit(SET_USER_DETAILS,{
      userDetails:null,
    }),
    context.commit(SET_USER_TOKEN,{
      token:null,
    })
    localStorage.removeItem('userDetails');
    localStorage.removeItem('token');
    if (timer) {
      clearTimeout(timer);
  }
   },

   [AUTO_LOGOUT_ACTION](context){
    context.dispatch(LOGOUT_ACTION);
    context.commit(SET_AUTO_LOGOUT_MUTATION);
   }
};